import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Table, Form } from 'semantic-ui-react';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { isEmpty } from 'lodash';

import ListRow from './ListRow';

class DealerDashboardList extends Component {
  render() {
    const {
      dealerDetails,
      localDealerNo,
      showProductSelection,
      isUpgradeAvailable,
      onChangeHandler,
      addDealerHandler,
      displayDealerConfirm,
      handleOpen,
      isAllOffersZero,
    } = this.props;
    const { name, auctionAccessNumber, enrollments } = dealerDetails;
    const listRow = ListRow(
      showProductSelection,
      isUpgradeAvailable,
      displayDealerConfirm,
      handleOpen,
      isAllOffersZero
    );
    const headerRow = (
      <Table.Row>
        <Table.HeaderCell width={8}>
          <Form widths='equal'>
            <Form.Group>
              <Form.Input
                name='add5m'
                placeholder='Add Unauthorized Dealer'
                value={localDealerNo}
                onChange={onChangeHandler('localDealerNo')}
              />
              <Form.Button
                color='green'
                onClick={addDealerHandler}
                inverted
                disabled={isEmpty(localDealerNo)}
              >
                Add dealer
              </Form.Button>
            </Form.Group>
          </Form>
        </Table.HeaderCell>
        <Table.HeaderCell className='enrollment-link' />
      </Table.Row>
    );

    return (
      <div>
        <div className='dealer-details'>
          <h4>
            {enrollments.length} Dealers associated with {name} [{
              auctionAccessNumber
            }{' '}
            ]
          </h4>
        </div>
        <Table
          celled
          selectable
          padded
          renderBodyRow={listRow}
          tableData={enrollments}
          headerRow={headerRow}
          size='small'
          striped
          compact='very'
          style={{ fontSize: '90%' }}
        />
      </div>
    );
  }
}

DealerDashboardList.propTypes = {
  dealerDetails: PropTypes.shape({
    name: PropTypes.string,
    auctionAccessNumber: PropTypes.string,
    enrollments: PropTypes.array,
  }).isRequired,
  localDealerNo: PropTypes.string,
  showProductSelection: PropTypes.func,
  isUpgradeAvailable: PropTypes.bool,
  onChangeHandler: PropTypes.func.isRequired,
  addDealerHandler: PropTypes.func.isRequired,
  displayDealerConfirm: PropTypes.func,
  handleOpen: PropTypes.func,
  isAllOffersZero: PropTypes.bool,
};

export default compose(withApollo, withRouter)(DealerDashboardList);
